// extracted by mini-css-extract-plugin
export var boldCellText = "b3fb028e7e242efdc5a3a4622e1c7026-css";